import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { StubLabel } from 'Components/Texts';
import { updateUserProfile } from 'State/User/UserActions';
import { GIFTING_QUERY_PARAM } from 'Utils/Constants';

export const EmailField = ({
  name,
  value = '',
  onBlur,
  handleChange,
  label,
  ariaLabel,
  autofocus,
  isDisabled,
  error,
  touched,
  className = '',
}) => {
  const location = useLocation();
  const routes = useSelector((s) => s.appConfig.routes);
  const isGifting = useSelector((s) => s.purchaseMode.isGifting);
  const existingUserError = error && error === 'existing-user';
  const dispatch = useDispatch();
  const user = useSelector((s) => s.user);
  let errorMessage = error;

  let inputClassName = `formFieldInput ${touched && error ? 'inputError' : ''}`;
  inputClassName = `${inputClassName} ${value || isDisabled ? 'hasValue' : ''}`;

  const labelId = label && !ariaLabel ? `emailInput-${label.replace(/\s+/g, '')}` : null;

  const searchParam = isGifting ? `${GIFTING_QUERY_PARAM}` : `return_to=${location.pathname}${location.search}`; //create account screen including params

  useEffect(() => {
    if (existingUserError || (touched && !error)) {
      const payload = { ...user, email: value };
      dispatch(updateUserProfile(payload));
    }
    // disable lint as we only want to dispatch updateUserProfile once when there is existing user error
    // or after user input valid email
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [existingUserError, touched, error]);

  if (existingUserError) {
    errorMessage = (
      <span>
        An account with this email already exists. Please{' '}
        <Link
          className="formFieldErrorInline"
          to={{
            pathname: routes.signin,
            search: searchParam,
            state: { from: location, page_source: 'other' },
          }}
        >
          sign in
        </Link>{' '}
        or use our{' '}
        <Link
          className="formFieldErrorInline"
          to={{
            pathname: routes.resetByEmail,
            state: { from: location },
          }}
        >
          forgot password
        </Link>{' '}
        service.
      </span>
    );
  }

  return (
    <div className={`formField formFieldEmail ${className}`}>
      <div className="animatedFieldContainer">
        <input
          className={inputClassName}
          name={name}
          value={value}
          onChange={handleChange}
          onBlur={onBlur}
          type="email"
          disabled={isDisabled}
          autoComplete="email"
          autoFocus={autofocus}
          aria-label={ariaLabel}
          aria-labelledby={labelId}
        />
        <StubLabel text={label} id={labelId} className="animatedLabel" />
        {touched && error && <div className="formFieldError">{errorMessage}</div>}
      </div>
    </div>
  );
};
